var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39984_16279",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 86,
    height: 86
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9997 84.6668C66.0122 84.6668 84.6664 66.0127 84.6664 43.0002C84.6664 19.9877 66.0122 1.3335 42.9997 1.3335C19.9872 1.3335 1.33301 19.9877 1.33301 43.0002C1.33301 66.0127 19.9872 84.6668 42.9997 84.6668Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7847 31.2148L31.2139 54.7857M31.2139 31.2148L54.7847 54.7857",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39984_16279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7 -7H93V93H-7V-7Z",
    fill: "#DC3545"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.743b614ca0e7f8b8265c435451f2c270.svg";
export { ForwardRef as ReactComponent };